import { Link } from 'react-router-dom';
import {
	FaPhoneAlt,
	FaFacebook,
	FaInstagram,
	FaPinterest,
	FaLinkedin,
	FaYoutube,
	FaRegEnvelope,
	FaGithub	 
} from "react-icons/fa";

const Footer = () => {
	return (
		<div className='container-footer'>
			<div className='footer-dividers'>
				<div className='footer-contact'>
					<h4 className='contact-title-footer'>CONTÁCTANOS</h4>
					<p className='contact-text'><FaRegEnvelope />contactokching@gmail.com</p>
					<p className='contact-text'><FaPhoneAlt />+54 3574-511196</p>
				</div>
				<div className='container-privacy'>
					<Link to='/' style={{textDecoration:'none'}} className='privacy-links'>Inicio</Link>
					<Link to='/servicios' style={{textDecoration:'none'}} className='privacy-links'>Servicios</Link>
					<Link to='/proyectos' style={{textDecoration:'none'}} className='privacy-links'>Portafolio</Link>
					<Link to='/nosotros' style={{textDecoration:'none'}} className='privacy-links'>Sobre K-Ching</Link>
					<Link to='/contacto' style={{textDecoration:'none'}} className='privacy-links'>Contacto</Link>
				</div>
				<div className='container-privacy'>
					<Link to='/privacy-policies' style={{textDecoration:'none'}} className='privacy-links'>Política de Privacidad</Link>
					<Link to='/purchasing-policies' style={{textDecoration:'none'}} className='privacy-links'>Política de Compras</Link>
					<Link to='/cookies-policies' style={{textDecoration:'none'}} className='privacy-links'>Política de Cookies</Link>
					<Link to='/servicios#faqs' style={{textDecoration:'none'}} className='privacy-links'>Preguntas Frecuentes</Link>
				</div>
				<div className='footer-newsletter'>
					<h4>Suscribite a nuestra newsletter</h4>
					<input type='email' className='input-newsletter' placeholder='Tu Email' />
					<button className='btn btn1'>Suscribirme</button>
				</div>
			</div>
			<div className='footer-copy-media'>
				<div className='footer-copy'>
					<span className='container-rights'>K-Ching {new Date().getFullYear()} &copy; Todos los Derechos Reservados.</span>
				</div>
				<div className='footer-logo'>
					<img src={require(`../../images/logo-2.png`)} alt='logo-2' />
				</div>
				<div className='footer-social-media'>
					<Link to='https://www.facebook.com/profile.php?id=61564867531134' className='contain-social-btn facebook' target='_blank' style={{textDecoration:'none'}}>
						<FaFacebook className='social-btn-icon' />
					</Link>
					<Link to='https://www.instagram.com/kching_ar/' className='contain-social-btn instagram' target='_blank' style={{textDecoration:'none'}}>
						<FaInstagram className='social-btn-icon' />
					</Link>
					<Link to='https://ar.pinterest.com/LeoBrizio98/' className='contain-social-btn pinterest' target='_blank' style={{textDecoration:'none'}}>
						<FaPinterest className='social-btn-icon' />
					</Link>
					<Link to='https://www.youtube.com/@K-ching' className='contain-social-btn youtube' target='_blank' style={{textDecoration:'none'}}>
						<FaYoutube className='social-btn-icon' />
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Footer;